import React, { useState } from "react";
import "./productcardcartbtn.css";
import { useSelector, useDispatch } from "react-redux";
import { getUserCart, updateUserCart } from "../../appState/slices/cart/cartSlice";
import QualityBlock from "../QualityBlock/QualityBlock";
import ColorBlocks from "../ColorBlocks/ColorBlocks";
import { X } from "phosphor-react";
import { setToastMessage } from "../../appState/slices/util/utilSlice";
const ProductCardCartBtn = ({product, name}) => {
    const dispatch = useDispatch();
    let color;
    let size;
    const [isSelectionOpen, setIsSelectionOpen] = useState(false);
    
    const [selectedColor, setSelectedColor] = useState(color);
    const [selectedSize, setSelectedSize] = useState(size);

    const toggleSelection = () => {
        setIsSelectionOpen(!isSelectionOpen);
    };

    const handleColorSelect = (color) => {
        setSelectedColor(color);
    };

    const handleSizeSelect = (size) => {
        setSelectedSize(size);
    };

    const addToCart = async() => {
        await dispatch(
            updateUserCart({
                product: product._id,
                color: selectedColor,
                size: selectedSize,
                quantity: 1,
                operation : "add"
            })   
        )

        await dispatch(
            setToastMessage({
              type: "done",
              show: true,
              itemmodal : true,
              product : product,
              color : selectedColor,
              timeout : 9000
            })
          )

        // Close the color/size selection div
        setIsSelectionOpen(false);
    };

    return (
        <div className="quick-add-selection-card">
            {!isSelectionOpen? 
            <div
            className={`quickaddbtn t7`}
            onClick={toggleSelection}
        >
            {name}
        </div>
        :
        null}
            

            {/* Color/Size Selection Div */}
            {isSelectionOpen && (
                <div className="color-size-selection">
                    {/* Color Options */}
                    <div className="color-options">
                        {product.colors.map((color, index) => (
                            <div
                                key={index}
                                className={` ${color === selectedColor ? "quickadd-selected-color"  : ""
                                    }`}
                                onClick={() => handleColorSelect(color)}
                            >
                                <ColorBlocks name={color} />
                            </div>
                        ))}
                    </div>

                    {/* Add to Cart Button */}
                    {/* <button onClick={addToCart}>Add to Cart</button> */}
                    <div className="options-buttoncontainer">
                        <div
                            className={`home-addtobagbtn t7`}
                            onClick={addToCart}
                        >
                            Add to bag
                        </div>
                        <div
                            className={`home-addtobagbtn options-close-button t7`}
                            onClick={toggleSelection}
                        >
                            <X />
                        </div>
                    </div>

                </div>
            )}
        </div>
    );
};

export default ProductCardCartBtn;
